import React from 'react';
import LoadState from 'src/components/LoadState/LoadState';
import Faqs from 'src/components/Faqs/Faqs';
import useFaqSearch from 'src/components/Faqs/CustomHooks/useFaqSearch';
import useFaqForm from 'src/components/Faqs/CustomHooks/useFaqForm';
import { FaqDocument } from 'src/components/Faqs/types';
import { FaqFormData } from 'src/components/Faqs/CustomHooks/useFaqForm';

export interface ItemFaqOperations {
  faqs: FaqDocument[];
  isLoadingFaqs: boolean;
  saveFaq: (faq: FaqFormData, action: any) => Promise<void>;
  deleteFaq: (faq: any) => Promise<void>;
  isSaving: boolean;
  validationStatus: any;
  lastSaveAction: any;
  resetValidation: () => void;
}

interface ItemFaqsProps {
  item: {
    id: string | number;
  };
  faqOperations: ItemFaqOperations;
}

const ItemFaqs = ({ item, faqOperations }: ItemFaqsProps) => {
  const {
    faqs,
    isLoadingFaqs,
    saveFaq,
    deleteFaq,
    isSaving,
    validationStatus,
    lastSaveAction,
    resetValidation,
  } = faqOperations;

  const { filteredFaqs, onSearch, searchQuery } = useFaqSearch(faqs);

  const {
    formData,
    setFormData,
    isEditing,
    showOverlay,
    openForm,
    closeForm,
    openFormForEdit,
  } = useFaqForm({
    validationStatus,
    lastSaveAction,
    onValidationSuccess: resetValidation,
  });

  return (
    <LoadState isLoading={isLoadingFaqs}>
      <Faqs
        faqs={filteredFaqs}
        onSearch={onSearch}
        searchQuery={searchQuery}
        onDeleteFaq={deleteFaq}
        formData={formData}
        setFormData={setFormData}
        isEditing={isEditing}
        showOverlay={showOverlay}
        onOpenForm={openForm}
        onCloseForm={closeForm}
        onEditFaq={openFormForEdit}
        onSaveFaq={saveFaq}
        isSaving={isSaving}
      />
    </LoadState>
  );
};

export default ItemFaqs;